import { createActions, createReducer } from 'reduxsauce'

import DetalhesLicitacaoService from '../../servicos/DetalhesLicitacaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDetalhesLicitacaoInicio: [],
    buscaDetalhesLicitacaoSucesso: ['detalhesLicitacao'],
    buscaDetalhesLicitacaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaDetalhesLicitacao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDetalhesLicitacaoInicio())
        let serv = new DetalhesLicitacaoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaDetalhesLicitacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDetalhesLicitacaoErro(error)))
    }
}

const buscaDetalhesLicitacaoInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaDetalhesLicitacaoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaDetalhesLicitacaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.detalhesLicitacao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DETALHES_LICITACAO_INICIO]: buscaDetalhesLicitacaoInicio,
    [Types.BUSCA_DETALHES_LICITACAO_ERRO]: buscaDetalhesLicitacaoErro,
    [Types.BUSCA_DETALHES_LICITACAO_SUCESSO]: buscaDetalhesLicitacaoSucesso,
})
